import React from 'react';
import { Skeleton, Box } from '@mui/material';

const UsuariosSkeleton = () => {
    // Número de filas del skeleton a mostrar
    const skeletonRows = 8;

    return (
        <Box>
            {/* Filas de la tabla */}
            {Array.from({ length: skeletonRows }).map((_, index) => (
                <Box
                    key={index}
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
                        gap: 2,
                        px: 3,
                        py: 2.5,
                        borderBottom: index < skeletonRows - 1 ? '1px solid #f0f0f0' : 'none',
                        alignItems: 'center',
                    }}
                >
                    {/* Columna: Nombre */}
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Skeleton variant="text" width="70%" height={20} />
                    </Box>

                    {/* Columna: Documento */}
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Skeleton variant="text" width="60%" height={20} />
                    </Box>

                    {/* Columna: Status (Badge) */}
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Skeleton variant="rounded" width={70} height={24} sx={{ borderRadius: '12px' }} />
                    </Box>

                    {/* Columna: Activo (Switch) */}
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Skeleton variant="rounded" width={44} height={24} sx={{ borderRadius: '12px' }} />
                    </Box>

                    {/* Columna: Editar (Botón) */}
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Skeleton variant="rounded" width={80} height={32} sx={{ borderRadius: '8px' }} />
                    </Box>
                </Box>
            ))}
        </Box>
    );
};

export default UsuariosSkeleton;
